import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { getMyApps } from '../../../reducers/agency/agencyActions';

import { ButtonPrimary } from 'texkit/dist/components/Buttons';

import {
  Container,
  FormActions,
  FormActionsItem,
  Trans,
} from '../../../components';

import { LINK_SERVICES_STEPS } from '.';

// AC2, AC3: Step Up Success screen showing confirmation with DPS services list.
const LinkServiceStepUpSuccess = ({ link, getMyApps, push }) => {
  if (!link || !link.app || !link.linkData) {
    return <Redirect to="/link" />;
  }

  const { linkData = {} } = link;
  const { licenseType = 'driver license' } = linkData;
  const isDL = licenseType === 'DL';
  const stepUpSuccessDescriptionId = isDL
    ? 'StepUpSuccessDescriptionDL'
    : 'StepUpSuccessDescriptionID';

  const handleViewDLOrID = async () => {
    await getMyApps();
    push('/agency/dps');
  };

  return (
    <div className="link-services step-up-success">
      <Container className="step-up-success-content">
        {/* AC3: Success heading */}
        <h2 className="page-header">
          <Trans file="LinkService" id="StepUpSuccessTitle" />
        </h2>

        {/* AC3: Supporting text with license type */}
        <p className="page-body">
          <Trans file="LinkService" id={stepUpSuccessDescriptionId} />
        </p>

        {/* AC3: Department label and services list */}
        <div className="step-up-success-services">
          <h3 className="step-up-success-services-header">
            <Trans file="LinkService" id="StepUpSuccessServiceDPS" />
          </h3>
          <ul className="services-list">
            <li className="services-list-item">
              <Trans
                file="LinkService"
                id="StepUpSuccessServiceDLAddressChange"
              />
            </li>
            <li className="services-list-item">
              <Trans file="LinkService" id="StepUpSuccessServiceDLRenewal" />
            </li>
            <li className="services-list-item">
              <Trans
                file="LinkService"
                id="StepUpSuccessServiceDLReplacement"
              />
            </li>
            <li className="services-list-item">
              <Trans file="LinkService" id="StepUpSuccessServiceDLSurrender" />
            </li>
            <li className="services-list-item">
              <Trans file="LinkService" id="StepUpSuccessServiceDLUpgrade" />
            </li>
            <li className="services-list-item">
              <Trans
                file="LinkService"
                id="StepUpSuccessServiceEmergencyContact"
              />
            </li>
          </ul>
        </div>

        {/* AC3, AC4: Primary CTA to view DL or ID */}
        <FormActions className="form-actions">
          <FormActionsItem>
            <ButtonPrimary
              onClick={handleViewDLOrID}
              className="step-up-success-cta"
            >
              <Trans file="LinkService" id="StepUpSuccessCTA" />
            </ButtonPrimary>
          </FormActionsItem>
        </FormActions>
      </Container>
    </div>
  );
};

LinkServiceStepUpSuccess.propTypes = {
  link: PropTypes.shape({
    app: PropTypes.shape({
      appSlug: PropTypes.string,
    }),
    linkData: PropTypes.shape({
      licenseType: PropTypes.string,
    }),
  }),
  getMyApps: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

const mapStateToProps = ({ agency }) => ({
  link: agency.link,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getMyApps,
      push,
    },
    dispatch
  );

const ConnectedLinkServiceStepUpSuccess = connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkServiceStepUpSuccess);

const RouteForLinkServiceStepUpSuccess = () => (
  <Route
    path={`/link/${LINK_SERVICES_STEPS.STEP_UP_SUCCESS}/:appSlug`}
    render={props => <ConnectedLinkServiceStepUpSuccess {...props} />}
  />
);

export default RouteForLinkServiceStepUpSuccess;
